<template>
  <div class="opm-level-parent">
    <div id="opm-level" v-if="!isSubLevel" style="width:100%;height:100%">
      <Level
        :key='selectedLevelString'
        :levelId='selectedLevelString'
        :mapConfig='mapConfig'
        :mode='modeString'
      />
    </div>
    <div id="opm-level" v-if="isSubLevel" style="width:100%;height:100%">
      <SubLevel
      :key='selectedLevelString'
      :levelId='selectedLevelString'
      :mapConfig='mapConfig'
      :mode='modeString'
      />
    </div>
  </div>
</template>

<script>
import Level from '@/components/level/Level.vue'
import SubLevel from '@/components/level/SubLevel.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'LevelView',
  props: {
    mode: {
      type: String,
      required: false
    }
  },
  components: {
    Level,
    SubLevel
  },
  methods: {
    /* updateDimensions() {
      this.width = (this.mode === 'player') ? this.playerDimensions.width : this.selectedDimensions.width
      this.height = (this.mode === 'player') ? this.playerDimensions.height : this.selectedDimensions.height
    } */
  },
  computed: {
    ...mapGetters([
      'selectedLevelString',
      'playerDimensions',
      'selectedDimensions'
    ]),
    mapConfig() {
      return {
        isDisabled: true,
        isZoomDisabled: true,
        isInteractionDisabled: true,
        mode: this.modeString,
        width: this.width,
        height: this.height,
        iconSize: 50
      }
    },
    width() {
      return (this.mode === 'player') ? this.playerDimensions.width : this.selectedDimensions.width
    },
    height() {
      return (this.mode === 'player') ? this.playerDimensions.height : this.selectedDimensions.height
    },
    isSubLevel() {
      if (this.mode === 'selected') {
        return true
      }
      return false
    },
    levelString() {
      return ''
    },
    modeString() {
      return this.mode
    }
  }
}
</script>

<style>
  #opm-level-parent {
    height: 100%;
    width: 100%;
  }
</style>
